import { render, staticRenderFns } from "./examCenter_addAndedit.vue?vue&type=template&id=4c218469&scoped=true"
import script from "./examCenter_addAndedit.vue?vue&type=script&lang=js"
export * from "./examCenter_addAndedit.vue?vue&type=script&lang=js"
import style0 from "./examCenter_addAndedit.vue?vue&type=style&index=0&id=4c218469&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c218469",
  null
  
)

export default component.exports